import { render, staticRenderFns } from "./IconArrowClose.vue?vue&type=template&id=51448dc1&"
import script from "./IconArrowClose.vue?vue&type=script&lang=js&"
export * from "./IconArrowClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports